import { useEffect, useState } from "react";
import { Menu, X, PhoneCall } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/site";

const NAV = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why-us" },
  { label: "Process", id: "process" },
  { label: "Results", id: "results" },
  { label: "FAQ", id: "faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,border-color] duration-300 border-b ${
        scrolled || open
          ? "bg-[#050A1E]/85 backdrop-blur-xl border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.4)]"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => go(item.id)}
              className="text-sm font-medium text-slate-300 hover:text-white transition-colors duration-200"
            >
              {item.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2.5">
          <button
            data-testid="header-cta-button"
            onClick={() => go("lead-form")}
            className="inline-flex items-center gap-2 gradient-bg text-white text-sm font-semibold px-4 sm:px-5 py-2.5 rounded-full hover:brightness-110 hover:shadow-[0_0_28px_rgba(99,102,241,0.55)] transition-[box-shadow,filter] duration-300"
          >
            <PhoneCall size={15} />
            <span className="hidden sm:inline">Get Free Strategy Call</span>
            <span className="sm:hidden">Free Call</span>
          </button>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2 rounded-lg border border-white/15"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden px-4 pb-5 pt-1 space-y-1" data-testid="mobile-menu">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`mobile-nav-${item.id}`}
              onClick={() => go(item.id)}
              className="block w-full text-left text-base font-medium text-slate-200 py-2.5 px-3 rounded-lg hover:bg-white/5"
            >
              {item.label}
            </button>
          ))}
          <button
            data-testid="mobile-header-cta-button"
            onClick={() => go("lead-form")}
            className="mt-2 w-full inline-flex items-center justify-center gap-2 gradient-bg text-white text-sm font-semibold px-5 py-3 rounded-full"
          >
            <PhoneCall size={15} />
            Get Free Strategy Call
          </button>
        </div>
      )}
    </header>
  );
};
